<template>
  <a v-if="data && data.url" v-track:clic_sitio_interes="{ dominio, url: data.url }" :href="data.url" target="_blank" rel="noopener noreferrer" class="site-card">
    <span class="site-card-thumb">
      <img v-if="imagen && !imageError" :src="imagen" alt="" loading="lazy" @error="imageError = true" />
      <img v-else-if="favicon && !faviconError" :src="favicon" alt="" class="site-card-favicon" loading="lazy" @error="faviconError = true" />
      <span v-else class="material-symbols-outlined">language</span>
    </span>

    <span class="site-card-body">
      <span class="site-card-title">{{ titulo || dominio }}</span>
      <span v-if="descripcion" class="site-card-desc">{{ descripcion }}</span>
      <span class="site-card-domain">
        {{ autor || dominio }}
        <span class="material-symbols-outlined">open_in_new</span>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  name: "sitiosInteres",
  props: ["data"],
  data() {
    return {
      imageError: false,
      faviconError: false,
    };
  },
  computed: {
    // Los metadatos pueden venir como objeto o como JSON en texto, con claves tipo "og:title", "twitter:image"…
    meta() {
      let m = this.data && this.data.metadata;
      if (typeof m === "string") {
        try {
          m = JSON.parse(m);
        } catch (e) {
          m = null;
        }
      }
      return m && typeof m === "object" ? m : {};
    },
    titulo() {
      return this.pick("title");
    },
    descripcion() {
      return this.pick("description");
    },
    autor() {
      return this.pick("authors");
    },
    imagen() {
      return this.pick("image");
    },
    dominio() {
      try {
        return new URL(this.data.url).hostname.replace(/^www\./, "");
      } catch (e) {
        return this.data.url;
      }
    },
    favicon() {
      try {
        return `https://www.google.com/s2/favicons?sz=64&domain=${new URL(this.data.url).hostname}`;
      } catch (e) {
        return "";
      }
    },
  },
  methods: {
    pick(fragment) {
      const key = Object.keys(this.meta).find((k) => k.toLowerCase().includes(fragment));
      const value = key ? this.meta[key] : "";
      return Array.isArray(value) ? value.join(", ") : (value || "").toString().trim();
    },
  },
};
</script>

<style scoped>
.site-card {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
  padding: 14px;
  border: 1px solid var(--sd-border);
  border-radius: 16px;
  background: var(--sd-surface);
  box-shadow: var(--sd-shadow);
  color: var(--sd-text);
  text-align: left;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.site-card:hover {
  transform: translateY(-2px);
  border-color: var(--sd-primary);
  box-shadow: var(--sd-shadow-lg);
  color: var(--sd-text);
  text-decoration: none;
}

.site-card:focus-visible {
  outline: 3px solid var(--sd-primary);
  outline-offset: 3px;
}

.site-card-thumb {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 76px;
  height: 76px;
  overflow: hidden;
  border-radius: 12px;
  background: var(--sd-surface-2);
}

.site-card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.site-card-thumb img.site-card-favicon {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.site-card-thumb .material-symbols-outlined {
  font-size: 32px;
  color: var(--sd-primary);
}

.site-card-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.site-card-title {
  display: -webkit-box;
  overflow: hidden;
  font-weight: 700;
  line-height: 1.3;
  color: var(--sd-text);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.2s;
}

.site-card:hover .site-card-title {
  color: var(--sd-primary);
}

.site-card-desc {
  display: -webkit-box;
  overflow: hidden;
  font-size: 0.85rem;
  line-height: 1.45;
  color: var(--sd-muted);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.site-card-domain {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  overflow: hidden;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--sd-gold);
}

.site-card-domain .material-symbols-outlined {
  font-size: 14px;
  color: inherit;
}
</style>
